const dimAcNoFilter = function dimAcNoFilter(input) {
  if (input) {
    return input.substring(0, 4) + " **** **** " + input.substring(input.length - 4);
  }
}

let filterObj = {}
filterObj.dimAcNo = dimAcNoFilter

export default filterObj
